import { useEffect } from 'react';
import './CubiInvestors.css';

const HERO_VIDEO = 'https://media.base44.com/videos/public/user_6a03217d215ab3f75f64add9/f3d3cf311_cubimay4202617779562.mp4';
const VOICEOVER_VIDEO = 'https://customer-assets.emergentagent.com/job_0786c46f-0c9a-4380-9edc-3feffcdbfb8d/artifacts/7yuo221x_cubimay122026%20with%20voice%20over.mp4';
const CALC_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api/static/cubi-noi-calculator.html';

const contentHTML = `
<div class="cubi-banner">Commercial Offices and Condo prices have dropped — CUBi is the solution!!</div>

<section class="cubi-unlock">
  <div class="grid">
    <div>
      <div class="badge">Vancouver, BC, Canada</div>
      <h1>Unlock the Value<br><span class="accent">Hiding in Plain Sight.</span></h1>
      <p class="desc">CUBi converts underutilized parking infrastructure into integrated, revenue-generating assets — self-storage, EV carshare, and clean energy — on the same footprint.</p>
      <div class="btns">
        <a class="cubi-btn-accent" href="#seed-round">Express Interest &rarr;</a>
        <a class="cubi-btn-outline" href="#solution">Explore the Solution</a>
      </div>
    </div>
    <div class="video-col">
      <p class="vid-title">Commercial Offices and Condo prices have dropped — <span class="accent">CUBi is the solution!!</span></p>
      <video src="${VOICEOVER_VIDEO}" controls playsinline></video>
    </div>
  </div>
</section>

<section class="cubi-stats-bar">
  <div class="stat"><div class="stat-val">35%</div><div class="stat-label">Office Vacancy Rate</div><div class="stat-sub">Metro Vancouver</div></div>
  <div class="stat"><div class="stat-val">$650+</div><div class="stat-label">Per sq ft</div><div class="stat-sub">Urban self-storage value</div></div>
  <div class="stat"><div class="stat-val">$169K</div><div class="stat-label">Value Per Stall</div><div class="stat-sub">Converted parking</div></div>
  <div class="stat"><div class="stat-val">250K+</div><div class="stat-label">Vacant Stalls</div><div class="stat-sub">Greater Vancouver</div></div>
</section>

<section class="cubi-dark">
  <div class="container">
    <div class="section-label">The Market Crisis</div>
    <h2>Three converging forces.<br>One unprecedented opportunity.</h2>
    <p class="section-desc">Urban real estate is under structural collapse. Office vacancy at 35%. Condo prices down 15% since 2022. Over 250,000 vacant residential stalls across Greater Vancouver generating zero return.</p>
    <div class="cards">
      <div class="card"><div class="num">01</div><h3>Office Vacancy Crisis</h3><div class="highlight">5.14M sq ft vacant</div><p>Metro Vancouver commercial assets desperately seeking new use cases.</p></div>
      <div class="card"><div class="num">02</div><h3>Condo Market Failure</h3><div class="highlight">3,500 stalled assemblies</div><p>Developers need alternative revenue streams to reach profitability.</p></div>
      <div class="card"><div class="num">03</div><h3>Parking Oversupply</h3><div class="highlight">42% condo, 55% office vacancy</div><p>Massive underutilized footprint with zero return sitting under every city block.</p></div>
    </div>
  </div>
</section>

<section id="solution" class="cubi-light">
  <div class="container">
    <div class="section-label">The CUBi Solution</div>
    <h2>Three revenue streams.<br>One parking footprint.</h2>
    <div class="cards">
      <div class="card"><div class="icon blue">&#x1f3ed;</div><div class="sub-label">Modular Self-Storage</div><h3>The Vault</h3><p>High-density, digitally managed storage units vertically optimized above parking footprint. 90% occupancy target at $300-$400/month.</p></div>
      <div class="card"><div class="icon green">&#x1f697;</div><div class="sub-label">Shared EV Mobility</div><h3>The Amenity Engine</h3><p>Building-based EV carshare fleet, e-bikes and e-scooters. Free for residents, commercial rates for public. Smart 3:1 charger ratio.</p></div>
      <div class="card"><div class="icon amber">&#x26a1;</div><div class="sub-label">Energy &amp; Grid Services</div><h3>The Power Layer</h3><p>Biogas CHP at 85% efficiency. Adsorption heat pumps, Virtual Power Plant, battery storage. Grid independence capability.</p></div>
    </div>
  </div>
</section>

<section class="cubi-callout">
  <div class="container">
    <div>
      <div class="section-label">Unit Economics</div>
      <h2>4 stalls &rarr; $371K+ annual revenue</h2>
      <p>1 SET = 4 vacant parking stalls &rarr; 6 storage units + 1 EV car + 2 chargers + 1 e-bike. Investment per SET: <strong>$52,000</strong>. Target: 10 SETs per building.</p>
    </div>
    <div style="display:flex;gap:1rem;flex-wrap:wrap">
      <a class="cubi-btn-accent" href="#seed-round">See the Numbers &nearr;</a>
    </div>
  </div>
</section>

<section class="cubi-light">
  <div class="container">
    <div class="section-label">The CUBi Stack</div>
    <h2>Six integrated revenue layers per building.</h2>
    <div class="cards" style="grid-template-columns:repeat(2,1fr)">
      <div class="card"><div class="icon green">&#x1f697;</div><div class="sub-label">Mobility Layer</div><h3>$3,200-4,800/mo</h3><p>7 EVs + 9 e-bikes via BYD supply chain</p></div>
      <div class="card"><div class="icon amber">&#x26a1;</div><div class="sub-label">Energy Layer</div><h3>$500-1,500/mo</h3><p>CHP generation + EV charging + VPP grid services</p></div>
      <div class="card"><div class="icon blue">&#x1f4e6;</div><div class="sub-label">Storage Layer</div><h3>$4,000-9,600/mo</h3><p>50-75 micro-lockers (5-50 sq ft)</p></div>
      <div class="card"><div class="icon green">&#x1f6e0;</div><div class="sub-label">Community Layer</div><h3>$1,200-3,000/mo</h3><p>Workshops, maker spaces, shared inventory</p></div>
      <div class="card"><div class="icon amber">&#x1f50b;</div><div class="sub-label">Resilience Layer</div><h3>$300-800/mo</h3><p>Emergency backup, peak shaving, grid independence</p></div>
      <div class="card"><div class="icon blue">&#x1f4e8;</div><div class="sub-label">Logistics Layer</div><h3>$500-1,200/mo</h3><p>Amazon-style smart lockers, last-mile delivery</p></div>
    </div>
  </div>
</section>

<section id="seed-round" class="cubi-inv">
  <div class="container">
    <div class="section-label">Seed Round — Now Open</div>
    <h2>$500,000 Seed Round Equity</h2>
    <p class="section-desc">Seed 1 at $0.15/share (July 2026) and Seed 2 at $0.25/share (October 2026). Limited partnership structures offer 8% preferred return + 111% profit share in Year 1.</p>
    <table>
      <thead><tr><th>Round</th><th>Shares</th><th>Price / Share</th><th>Target Raise</th><th>Timeline</th></tr></thead>
      <tbody>
        <tr><td>Seed 1</td><td>1,000,000</td><td>$0.15</td><td>$150,000</td><td>July 2026</td></tr>
        <tr><td>Seed 2</td><td>1,400,000</td><td>$0.25</td><td>$350,000</td><td>October 2026</td></tr>
        <tr><td class="bold">Total</td><td class="bold">2,400,000</td><td></td><td class="accent">$500,000</td><td></td></tr>
      </tbody>
    </table>
  </div>
</section>

<section class="cubi-inv cubi-inv-border">
  <div class="container">
    <div class="section-label">Returns</div>
    <h2>Limited Partnership Returns</h2>
    <p class="section-desc">Per-building LP structure with equipment co-ownership and revenue sharing.</p>
    <div class="stat-grid">
      <div class="stat-card"><div class="val">$750K-$1.5M</div><div class="label">Investment Range</div><div class="sub">per project</div></div>
      <div class="stat-card"><div class="val">8%</div><div class="label">Preferred Return</div><div class="sub">annually, paid quarterly</div></div>
      <div class="stat-card"><div class="val">100%</div><div class="label">Year 1 Rev Split</div><div class="sub">to investors (after 8% pref)</div></div>
      <div class="stat-card"><div class="val">111%</div><div class="label">Year 1 Profit Share</div><div class="sub">annual profit share</div></div>
      <div class="stat-card"><div class="val">62%</div><div class="label">Year 2 Profit Share</div><div class="sub">investors</div></div>
      <div class="stat-card"><div class="val">48%</div><div class="label">Ongoing</div><div class="sub">profit share continuing</div></div>
    </div>
    <p class="note"><strong>LP Exit Option:</strong> Units convertible to parent company shares at <span class="accent">25% discount</span> after 2 years.</p>
    <p class="note" style="margin-top:0.75rem"><strong>Tax Depreciation:</strong> 81% over 3 years — <span class="accent">405% effective return</span> on 20% equity through leveraged depreciation.</p>
  </div>
</section>

<section class="cubi-inv cubi-inv-border">
  <div class="container">
    <div class="section-label">Tax Benefits</div>
    <h2>Tax-Advantaged Structures</h2>
    <p class="section-desc">CUBi investments qualify for exceptional Canadian tax benefits unavailable to most competitors.</p>
    <table>
      <thead><tr><th>Program</th><th>Benefit</th><th>Eligibility</th></tr></thead>
      <tbody>
        <tr><td>EBC (Eligible Business Corporation)</td><td>30% refundable tax credit</td><td>BC residents / corporations</td></tr>
        <tr><td>Accelerated CCA</td><td>45-75% depreciation</td><td>Clean tech equipment</td></tr>
        <tr><td>Leveraged Depreciation</td><td>100% depreciation on 100% capital</td><td>LP structure, 20-45% equity</td></tr>
      </tbody>
    </table>
  </div>
</section>

<section class="cubi-partner">
  <div class="container">
    <div class="section-label">Partnerships</div>
    <h2>Three Ways to Join</h2>
    <p class="section-desc">Choose the partnership structure that fits your goals.</p>
    <div class="grid">
      <div class="pcard"><div class="type">Revenue Share</div><h3>Joint Venture</h3><ul><li>50/50 revenue split</li><li>Shared risk, shared upside</li><li>Your brand + our tech</li><li>CHP/VPP integration included</li></ul><div class="best">Best for: Strategic entry</div></div>
      <div class="pcard featured"><div class="fbadge">Recommended</div><div class="type">Recommended</div><h3>White-Label Management</h3><ul><li>12-15% management fee</li><li>Performance bonus</li><li>We own, you operate</li><li>VPP revenue shared</li></ul><div class="best">Best for: Operational focus</div></div>
      <div class="pcard"><div class="type">Investment</div><h3>Strategic Equity</h3><ul><li>15-25% equity stake</li><li>Board representation</li><li>ROFR on expansion</li><li>Exit: $50-100M by 2031</li></ul><div class="best">Best for: Long-term value</div></div>
    </div>
  </div>
</section>

<section class="cubi-inv">
  <div class="container">
    <div class="section-label">Competitive Advantage</div>
    <h2>Competitive Moats</h2>
    <div class="cards" style="margin-top:2rem">
      <div class="card"><div class="num">01</div><h3>Regulatory Arbitrage</h3><p>3:1 parking-to-storage conversion ratio permitted when EV carshare is provided.</p></div>
      <div class="card"><div class="num">02</div><h3>First-Mover Advantage</h3><p>No integrated competitor in Canadian urban self-storage with this combined model.</p></div>
      <div class="card"><div class="num">03</div><h3>Relationship Network</h3><p>300+ strata/building relationships via the founding team — pipeline already in place.</p></div>
    </div>
  </div>
</section>

<section class="cubi-inv cubi-inv-border">
  <div class="container">
    <div class="section-label">Roadmap</div>
    <h2>Growth Strategy</h2>
    <div class="phase-grid" style="margin-top:2rem">
      <div class="phase-card"><div class="phase-label">Phase 1 <span class="phase-year">— 2026</span></div><h3>Pilot &amp; Proof</h3><ul><li>North Vancouver trial location</li><li>Product development &amp; testing</li><li>60+ prospect site feasibility studies</li></ul></div>
      <div class="phase-card"><div class="phase-label">Phase 2 <span class="phase-year">— 2027</span></div><h3>Franchise Scale</h3><ul><li>BC PNP Franchises: 2 initial ($375K each)</li><li>US Expansion: Florida (EB-5) + California</li><li>Ontario provincial nominee programs</li></ul></div>
      <div class="phase-card"><div class="phase-label">Phase 3 <span class="phase-year">— 2028-29</span></div><h3>National &amp; Liquidity</h3><ul><li>150+ buildings under management</li><li>Potential IPO, RTO, or STO</li><li>Strategic acquisition by REIT</li></ul></div>
    </div>
  </div>
</section>

<section class="cubi-inv cubi-inv-border">
  <div class="container">
    <div class="section-label">Liquidity</div>
    <h2>Exit Pathways</h2>
    <table style="margin-top:2rem">
      <thead><tr><th>Pathway</th><th>Target / Structure</th><th>Timeline</th></tr></thead>
      <tbody>
        <tr><td>Strategic Sale</td><td>REIT, self-storage operator, or PE</td><td>3-5 years</td></tr>
        <tr><td>Management Buyout (BOOT)</td><td>Building owner buys out CUBi at 2x+</td><td>2+ years</td></tr>
        <tr><td>IPO / RTO / STO</td><td>Public listing, traditional or blockchain</td><td>5-7 years</td></tr>
        <tr><td>LP Unit Conversion</td><td>Exchange for parent shares at discount</td><td>2+ years</td></tr>
        <tr><td>Dividend Distributions</td><td>Ongoing yield from operational cash flow</td><td>Post-profitability</td></tr>
      </tbody>
    </table>
  </div>
</section>
`;

export default function CubiInvestors() {
  useEffect(() => { document.title = 'CUBi.ltd | Investors'; }, []);

  return (
    <div className="cubi-page" data-testid="cubi-investors-page">
      <a href={CALC_URL} target="_blank" rel="noopener noreferrer" className="cubi-calc-sticky" data-testid="noi-calc-btn">NOI Calculator</a>
      <div dangerouslySetInnerHTML={{ __html: contentHTML }} />
    </div>
  );
}
